const t = "_container_8781k_1", o = "_entityColor1_8781k_16", n = "_disabled_8781k_19", i = "_entityColor2_8781k_22", r = "_entityColor3_8781k_28", e = "_entityColor4_8781k_34", _ = "_entityColor5_8781k_40", l = "_entityColor6_8781k_46", y = "_entityColor7_8781k_52", C = "_entityColor8_8781k_58", k = "_entityColor1Light_8781k_64", s = "_entityColor2Light_8781k_70", c = "_entityColor3Light_8781k_76", a = "_entityColor4Light_8781k_82", h = "_entityColor5Light_8781k_88", g = "_entityColor6Light_8781k_94", D = "_entityColor7Light_8781k_100", L = "_entityColor8Light_8781k_106", d = "_entityColor1Dark_8781k_112", b = "_entityColor2Dark_8781k_118", u = "_entityColor3Dark_8781k_124", f = "_entityColor4Dark_8781k_130", p = "_entityColor5Dark_8781k_136", x = "_entityColor6Dark_8781k_142", j = "_entityColor7Dark_8781k_148", m = "_entityColor8Dark_8781k_154", q = {
  container: t,
  "thickness-thin": "_thickness-thin_8781k_4",
  "thickness-regular": "_thickness-regular_8781k_8",
  "thickness-thick": "_thickness-thick_8781k_12",
  entityColor1: o,
  disabled: n,
  entityColor2: i,
  entityColor3: r,
  entityColor4: e,
  entityColor5: _,
  entityColor6: l,
  entityColor7: y,
  entityColor8: C,
  entityColor1Light: k,
  entityColor2Light: s,
  entityColor3Light: c,
  entityColor4Light: a,
  entityColor5Light: h,
  entityColor6Light: g,
  entityColor7Light: D,
  entityColor8Light: L,
  entityColor1Dark: d,
  entityColor2Dark: b,
  entityColor3Dark: u,
  entityColor4Dark: f,
  entityColor5Dark: p,
  entityColor6Dark: x,
  entityColor7Dark: j,
  entityColor8Dark: m
};
export {
  t as container,
  q as default,
  n as disabled,
  o as entityColor1,
  d as entityColor1Dark,
  k as entityColor1Light,
  i as entityColor2,
  b as entityColor2Dark,
  s as entityColor2Light,
  r as entityColor3,
  u as entityColor3Dark,
  c as entityColor3Light,
  e as entityColor4,
  f as entityColor4Dark,
  a as entityColor4Light,
  _ as entityColor5,
  p as entityColor5Dark,
  h as entityColor5Light,
  l as entityColor6,
  x as entityColor6Dark,
  g as entityColor6Light,
  y as entityColor7,
  j as entityColor7Dark,
  D as entityColor7Light,
  C as entityColor8,
  m as entityColor8Dark,
  L as entityColor8Light
};
//# sourceMappingURL=index.es567.js.map
